import { AppDataQueries, AppDataQueryKey } from '@/lib/app-data';
import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';

const useAppData = <T>(
  queryKey: AppDataQueryKey,
  queryOptions?: Omit<UseQueryOptions<T>, 'queryKey' | 'queryFn'>
): UseQueryResult<T> => {
  const { queryFn, options } = AppDataQueries.get(queryKey) || {};
  return useQuery(queryKey, queryFn!, { ...options, ...queryOptions });
};

export default useAppData;
